"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpanderWithArrow = ExpanderWithArrow;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const expander_arrow_1 = require("./expander-arrow");
const PositionedArrow = (0, styled_components_1.default)(expander_arrow_1.ExpanderArrow) `
  position: absolute;
  top: 20%;
  left: 0;
`;
function ExpanderWithArrow({ isCollapsed, onToggle, text, className }) {
    return (React.createElement(Expander, { className: className },
        React.createElement(ExpanderClickableSurface, { onClick: onToggle },
            React.createElement(PositionedArrow, { isCollapsed: isCollapsed },
                React.createElement("span", null)),
            React.createElement(GroupHeading, null, text))));
}
const Expander = styled_components_1.default.div `
  padding: 10px 0 10px 25px;
  position: relative;
`;
const ExpanderClickableSurface = styled_components_1.default.div `
  display: inline-block;
  cursor: pointer;
`;
const GroupHeading = styled_components_1.default.h3 `
  font-size: 12px;
`;
//# sourceMappingURL=expander-with-arrow.js.map